import Shepherd from 'shepherd.js';
if($('.network-administration-applications').length){

    ['close', 'cancel', 'complete'].forEach(event => Shepherd.on(event, () => {
        var data = {
            'page': 'network-administration-applications'
        };
        axios.post("/api/v1/onboarding", data)
        .then((response) =>  {
        }).catch(function (error) {
            console.log('onboarding logged')
        });
    }));

    var dataType = $('.network-administration-applications').attr('data-type');
    
    const tour = new Shepherd.Tour({
        defaultStepOptions: {
            cancelIcon: {
                enabled: true
            },
            classes: 'shepherd-container',
            scrollTo: { behavior: 'smooth', block: 'center' }
        },
        useModalOverlay: true
    });
    
    tour.addStep({
        title: 'Managing your applications',
        text: "On this page you can manage your applications. Regardless of whether you are reviewing innovations or experts, the views are almost identical, however, you'll have some different columns on the table. This guide will cover the features to help you manage the applications.",
        buttons: [
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-1'
    });
    
    tour.addStep({
        title: 'Searching applications',
        text: "To help you quickly find an application, you can use this search bar which will check against the applicant's name and the title of the innovation (if it is an innovation application).",
        attachTo: {
            element: '#search-applications',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-2'
    });
    
    if($('#status-selector').length){

        tour.addStep({
            title: "Filtering by status",
            text: "By default we're currently showing you approved applications. If you wish to see all applications, or only pending or dissaproved applications, you can switch between them here.",
            attachTo: {
                element: '#status-selector',
                on: 'bottom'
            },
            buttons: [
                {
                    action() {
                        return this.back();
                    },
                    classes: 'btn btn--border',
                    text: 'Back'
                },
                {
                    action() {
                        return this.next();
                    },
                    classes: 'btn btn--secondary',
                    text: 'Next'
                }
            ],
            id: 'step-3'
        });
    }
    
    tour.addStep({
        title: "Changing the date range",
        text: "If you wish to see applications before, after, or between two dates, you may use these selectors to filter them.",
        attachTo: {
            element: '#date-selectors',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-4'
    });

    tour.addStep({
        title: "Changing the view",
        text: "If you want to see a more visual view of your applications, you can toggle between grid and table view using these two buttons.",
        attachTo: {
            element: '#view-toggle',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-6'
    });
    
    tour.addStep({
        title: "Reset filters",
        text: "If you wish to quickly remove all of the filters you've chosen, clicking this button will reset all of the filters to default.",
        attachTo: {
            element: '#reset-button',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-8'
    });
    
    tour.addStep({
        title: "Table sorting",
        text: "You can change the ordering on every column by clicking the arrows next to the name of each column. Toggling these will switch between ascending, descending and default ordering.",
        attachTo: {
            element: '.vgt-responsive thead',
            on: 'bottom'
        },
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.next();
                },
                classes: 'btn btn--secondary',
                text: 'Next'
            }
        ],
        id: 'step-8'
    });
    
    tour.addStep({
        title: "What next?",
        text: "Once you've had a chance to look around this page and you've recieved your first application, click on the eye icon displayed on each application row on the table, or on an application card in grid view, to go and have a look at the full application.",
        buttons: [
            {
                action() {
                    return this.back();
                },
                classes: 'btn btn--border',
                text: 'Back'
            },
            {
                action() {
                    return this.complete();
                },
                classes: 'btn btn--secondary',
                text: 'Finish'
            }
        ],
        id: 'step-9'
    });

    $('.replay-onboarding').show();
    
    $('.replay-onboarding').click(function(){
        tour.start();
    });

    if(!$('.onboarding-network-administration-applications').length){
        tour.start();
    }
}
